module.exports = __webpack_public_path__ + "img/logo_apple_pay.fac863c.svg";